import { Drawer, IconButton, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';

import styled from 'styled-components';

import { getColorHeader, fontFamily } from '../../../../libs';

export const Container = styled(Drawer)`
  .MuiPaper-root {
    &::-webkit-scrollbar {
      width: 8px !important;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px #00000040 !important;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c9c9c9;
      border-radius: 3px;
    }
  }

  .MuiDrawer-paperAnchorLeft {
    width: 90% !important;
  }
`;

export const HeaderDrawer = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  background: ${getColorHeader};
  color: #fff;
  align-items: center;
  padding: 5px 10px;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    font-size: 25px;
    color: #fff;
  }
`;

export const HeaderTextContainer = styled.div`
  text-align: center;
  white-space: initial;
  padding: 0 5px;

  a {
    margin: 0 5px;
  }
`;

export const ButtonIcon = styled(IconButton)`
  padding: 5px;
`;

export const ExpansionPanelStyled = styled(Accordion)`
  width: 100%;
  margin: 0 !important;
  padding: 0 12px !important;
`;

export const ExpansionPanelSummaryStyled = styled(AccordionSummary)`
  width: 100% !important;
  padding: 12px 0px !important;
  height: 45px !important;
  min-height: unset !important;

  font-family: ${fontFamily};
  font-weight: bold;
  text-shadow: ${({ category }) => (category ? `0 1px 2px #00000020` : 'unset')};

  * {
    color: ${({ category, theme }) => (category ? `${theme.colors.header}` : '#555555')} !important;
  }
`;

export const ExpansionPanelDetailsStyled = styled(AccordionDetails)`
  width: 100% !important;
  padding: 0 !important;
  flex-direction: column !important;
`;

export const MenuContainer = styled.nav`
  max-height: 80vh;
`;

export const Link = styled.a`
  padding: 12px 12px !important;
  color: #555555;
  font-weight: bold;
  min-height: unset !important;
  height: 45px !important;
`;

export default {};
